<template>
  <SogCard class="sog-card-without-title">
    <!--
    <SogCardTitle>Adresse</SogCardTitle>
-->
    <SogCardContent>
      <SogForm
        ref="_formActivation"
        :validations="_durationValidation"
      >
        <SogFormField>
          <SogNumericTextBox
            v-model="_activationDuration"
            placeholder="eVB-Gültigkeit (Tage)"
            name="activationDuration"
            format="n"
            width="220px"
          />
        </SogFormField>
        <PersonAddressEditComponent
          ref="_personAddressForm"
          :person="_person"
          :address="_address"
        />
      </SogForm>
      <SogCheckBox
        v-show="!showSaveAddress"
        v-model="_saveAddress"
        width="220px"
        placeholder="Diese Adresse für zukünftige eVB-Aktivierungen speichern"
      />
    </SogCardContent>
    <SogCardActions>
      <SogCardActionButton
        mdi-icon="mdi-check"
        @click="onActivationOk"
      >
        Ok
      </SogCardActionButton>
      <SogCardActionButton
        mdi-icon="mdi-cancel"
        @click="onActivationCancel"
      >
        {{ cancelButtonText ?? 'Abbrechen' }}
      </SogCardActionButton>
    </SogCardActions>
  </SogCard>
</template>

<script setup lang="ts">

import SogForm from "@/shared/ui/SogForm.vue";
import SogCardActionButton from "@/shared/ui/SogCardActionButton.vue";
import SogCard from "@/shared/ui/SogCard.vue";
import SogFormField from "@/shared/ui/SogFormField.vue";
import SogNumericTextBox from "@/shared/ui/SogNumericTextBox.vue";
import SogCardActions from "@/shared/ui/SogCardActions.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import SogCheckBox from "@/shared/ui/SogCheckBox.vue";
import PersonAddressEditComponent from "@/modules/OrganisationStructure/components/PersonAddressEditComponent.vue";
import Person from "@/shared/model/person";
import Address from "@/shared/model/Address";
import {onMounted, reactive, ref, watch} from "vue";
import {replaceWith} from "@/shared/utils/CopyTo";
import PersonDetailsId from "@/shared/model/personDetailsId";
import {onBeforeRouteUpdate} from "vue-router";
import {useAccountStore} from "@/stores/accountStore";
import PersonAddressForm from "@/modules/OrganisationStructure/components/PersonAddressEditComponent.vue";
import SogFormValidationRule from "@/shared/ui/types/SogFormValidationRule";

interface Props {
  person?: Person | undefined
  address?: Address | undefined
  cancelButtonText?: string
  showSaveAddress?: boolean
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = withDefaults(defineProps<Props>(), {
    person: undefined, address: undefined, cancelButtonText: undefined, showSaveAddress: false
  }
)


const _emit = defineEmits<{
  (e: 'clickCancel'): void,
  (e: 'clickOk', value: { activationDuration: number, person: Person, address: Address, saveAddress: boolean }): void
}>();


const _person = reactive<Person>(new Person())
const _address = reactive<Address>(new Address())
const _saveAddress = ref(false)
const _activationDuration = ref(30)
const _accountStore = useAccountStore()
const _formActivation = ref<InstanceType<typeof SogForm> | null>(null)
const _personAddressForm = ref<InstanceType<typeof PersonAddressForm> | null>(null)
const _durationValidation: SogFormValidationRule[] = [
  {name: 'activationDuration', rules: {required: [true, "1 bis 90 Tage"], min: 1, max: 90}},
]


watch(props, () => {
    if (props.person) {
      replaceWith(props.person, _person);
    }
    if (props.address) {
      replaceWith(props.address, _address);
    }
    if (props.showSaveAddress) {
      _saveAddress.value = false;
    }
    // deep: Props sind shallowReactive – ohne deep feuert der Watch nur bei
    // Referenzwechsel, nicht wenn person/address in-place mutiert werden.
  }, {immediate: true, deep: true}
)


async function p_init() {
  const t_default = _accountStore.details?.getNumberValue(PersonDetailsId.EvbActivationDefaultDuration) ?? (_accountStore.isBranch ? 7 : 30)
  const t_max = _accountStore.details?.getNumberValue(PersonDetailsId.EvbActivationMaxDuration) ?? (_accountStore.isBranch ? 30 : _accountStore.isRoot ? 180 : 90)
  _formActivation.value.removeRules("activationDuration")
  _formActivation.value.addRules({
    name: 'activationDuration',
    rules: {required: [true, "1 bis " + t_max + " Tage"], min: 1, max: t_max}
  })
  _activationDuration.value = t_default;
}

onMounted(async () => {
  await p_init()
})

onBeforeRouteUpdate(async () => {
//  await p_init()
});

function onActivationCancel() {
  _emit("clickCancel")
}

async function onActivationOk() {
  if (_formActivation.value.validate() && _personAddressForm.value.validate()) {
    _emit("clickOk", {activationDuration: _activationDuration.value, person: _person, address: _address, saveAddress: _saveAddress.value})
  }
}


</script>

<style scoped>

</style>
